import React from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components'

import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VFButton from '../VFButton/VFButton'

import { Images, getThemeImages } from '../../Themes'

import styles from './OfferContent.Styles'


const OfferContent = ({
  offer,
  summary,
  buttonLoading,
  selectOffer,
  theme,
}) => {

  const themedImages = getThemeImages(theme.name)

  const getIcon = (type) => {
    switch (type) {
      case 'MOBILE_GB':
        return themedImages.dataSharing
      case 'INTERNATIONAL_SMS':
        return themedImages.smsText
      case 'SMS':
        return themedImages.smsText
      case 'INTERNATIONAL_MIN':
        return themedImages.landline
      case 'MIN':
        return themedImages.landline
      default:
        return ''
    }
  }

  return (
    <View style={styles.container(!summary, theme)}>
      <View style={styles.rowContainer}>
        {offer?.content.map(item => {
          return (
            <View style={styles.rowItem} >
              <Icon
                name={getIcon(item?.type)}
                type="image"
                size={25}
                resizeMode="contain"
              />
              <VFText
                i18nKey={item?.value}
                style={styles.title(theme)}
              />
              <VFText
                i18nKey={`acqusition_${item?.type}`}
                style={styles.detail(theme)}
              />
            </View>
          )
        })}
      </View>
      {offer?.extraContent && <View style={styles.extraContentContainer}>
        <VFText
          i18nKey={offer?.extraContent?.title ?? ''}
          style={styles.extraContentTitle}
        />
        <View style={styles.iconsContainer}>
          {offer?.extraContent?.products.map(el =>
            <Icon
              name={el.product}
              type="image"
              size={45}
              resizeMode="contain"
              style={styles.icon}
            />
          )}
        </View>
      </View>}
      {!summary && <View style={styles.buttonContainer(theme)}>
        <VFButton
          title="acquisition_offer_button_title"
          type="primary"
          onPress={() => selectOffer(offer)}
          isLoading={buttonLoading}
          loadingTitle="acquisition_loading_button"
        />
      </View>}
    </View>
  )
}

OfferContent.defaultProps = {
  summary: false
}

OfferContent.propTypes = {
  offer: PropTypes.objectOf({
    content: PropTypes.arrayOf({
      icon: PropTypes.string,
      title: PropTypes.string,
    }),
    extraContent: PropTypes.objectOf({
      title: PropTypes.string,
      products: PropTypes.array,
    }),
  }),
  summary: PropTypes.bool,
  selectOffer: PropTypes.func,
  buttonLoading: PropTypes.bool,
  theme: PropTypes.object,
}

export default withTheme(OfferContent)
